import { render } from "./HighBoard.vue?vue&type=template&id=5d3cd2c2"
import script from "./HighBoard.vue?vue&type=script&lang=js"
export * from "./HighBoard.vue?vue&type=script&lang=js"

import "./HighBoard.vue?vue&type=style&index=0&id=5d3cd2c2&noscoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__